"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VenueRemovalNotificationTypes = void 0;
var VenueRemovalNotificationTypes;
exports.VenueRemovalNotificationTypes = VenueRemovalNotificationTypes;
(function (VenueRemovalNotificationTypes) {
  VenueRemovalNotificationTypes["API_KEY_IP_BANNED"] = "ApiKeyIpBanned";
  VenueRemovalNotificationTypes["CANCEL_ON_MAX_SLIPPAGE_EXCEEDED"] = "CancelOnMaxSlippageExceeded";
  VenueRemovalNotificationTypes["CANCEL_ON_VENUE_DROPPED"] = "CancelOnVenueDropped";
  VenueRemovalNotificationTypes["DAILY_ORDER_LIMIT"] = "DailyOrderLimit";
  VenueRemovalNotificationTypes["EXCEEDED_TRADE_LIMIT"] = "ExceededTradeLimit";
  VenueRemovalNotificationTypes["EXCHANGE_CLOSED"] = "ExchangeClosed";
  VenueRemovalNotificationTypes["INACTIVE_INSTRUMENT"] = "InactiveInstrument";
  VenueRemovalNotificationTypes["INCORRECT_QUANTITY"] = "IncorrectQuantity";
  VenueRemovalNotificationTypes["INSUFFICIENT_FUNDS"] = "InsufficientFunds";
  VenueRemovalNotificationTypes["INVALID_CREDS"] = "InvalidCreds";
  VenueRemovalNotificationTypes["INVALID_PRICE"] = "InvalidPrice";
  VenueRemovalNotificationTypes["INVALID_PRICE_INC"] = "InvalidPriceInc";
  VenueRemovalNotificationTypes["INVALID_PRICE_MAX"] = "InvalidPriceMax";
  VenueRemovalNotificationTypes["INVALID_PRICE_MIN"] = "InvalidPriceMin";
  VenueRemovalNotificationTypes["INVALID_QUANT_INC"] = "InvalidQuantInc";
  VenueRemovalNotificationTypes["MAINTENANCE_WINDOW"] = "MaintenanceWindow";
  VenueRemovalNotificationTypes["MARKET_CLOSED"] = "MarketClosed";
  VenueRemovalNotificationTypes["MISCONFIGURED_API_KEYS"] = "MisconfiguredApiKeys";
  VenueRemovalNotificationTypes["MULTI_VENUE_NOT_SUPPORTED"] = "MultiVenueNotSupported";
  VenueRemovalNotificationTypes["NO_GTC_SUPPORTED_VENUES"] = "NoGtcSupportedVenues";
  VenueRemovalNotificationTypes["NO_HISTORICAL_VOLUME_MODEL"] = "NoHistoricalVolumeModel";
  VenueRemovalNotificationTypes["NOT_SPECIFIED"] = "NotSpecified";
  VenueRemovalNotificationTypes["ORD_QUANT_TOO_BIG"] = "OrdQuantTooBig";
  VenueRemovalNotificationTypes["ORD_QUANT_TOO_SMALL"] = "OrdQuantTooSmall";
  VenueRemovalNotificationTypes["OTHER"] = "Other";
  VenueRemovalNotificationTypes["PRICE_EXCEEDS_BAND"] = "PriceExceedsBand";
  VenueRemovalNotificationTypes["SELF_TRADE"] = "SelfTrade";
  VenueRemovalNotificationTypes["THROTTLE_LIMIT"] = "ThrottleLimit";
  VenueRemovalNotificationTypes["UNKNOWN_ACCOUNT"] = "UnknownAccount";
  VenueRemovalNotificationTypes["UNKNOWN_SYMBOL"] = "UnknownSymbol";
  VenueRemovalNotificationTypes["UNSUPPORTED_INSTRUMENT"] = "UnsupportedInstrument";
  VenueRemovalNotificationTypes["UNTRADABLE_AMOUNT"] = "UntradableAmount";
  VenueRemovalNotificationTypes["VENUE_NOT_SUPPORTED"] = "VenueNotSupported";
})(VenueRemovalNotificationTypes || (exports.VenueRemovalNotificationTypes = VenueRemovalNotificationTypes = {}));
var _default = VenueRemovalNotificationTypes;
exports.default = _default;